/* tslint:disable */
/* eslint-disable */
/**
 * cro-fiona-search
 * Fiona Search Service
 *
 * The version of the OpenAPI document: 0.2.171
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

/**
 * LegacyControllerApi - interface
 * 
 * @export
 * @interface LegacyControllerApiInterface
 */
export interface LegacyControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyControllerApiInterface
     */
    legacyControllerGetEmbedParametersRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<{ [key: string]: object; }>>;

    /**
     */
    legacyControllerGetEmbedParameters(initOverrides?: RequestInit): Promise<{ [key: string]: object; }>;

}

/**
 * 
 */
export class LegacyControllerApi extends runtime.BaseAPI implements LegacyControllerApiInterface {

    /**
     */
    async legacyControllerGetEmbedParametersRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<{ [key: string]: object; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/legacy/getEmbedParameters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async legacyControllerGetEmbedParameters(initOverrides?: RequestInit): Promise<{ [key: string]: object; }> {
        const response = await this.legacyControllerGetEmbedParametersRaw(initOverrides);
        return await response.value();
    }

}
